import React, { Fragment } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { If } from 'src/Components/Conditionals'
import Text from 'src/Components/Text'
import Button from 'src/Components/Button'
import PrequalAvatar from 'src/features/buyers/Components/Global/AffordabilityModal/PrequalTab/PrequalAvatar'
import PrequalTabFooter from 'src/features/buyers/Components/Global/AffordabilityModal/PrequalTab/PrequalTabFooter'

import styles from './GetPrequal.module.scss'

const propTypes = {
  className: PropTypes.string,
  customerProfileFirstName: PropTypes.string,
  customerProfilePhotoUri: PropTypes.string,
  isSponsored: PropTypes.bool,
  sponsorProfileFullName: PropTypes.string,
  sponsorPhotoUri: PropTypes.string,
  onRequest: PropTypes.func
}

const GetPrequal = ({
  className,
  customerProfileFirstName,
  customerProfilePhotoUri,
  isSponsored,
  sponsorProfileFullName,
  sponsorPhotoUri,
  onRequest
}) => (
  <Fragment>
    <PrequalAvatar className={styles.avatar} src={customerProfilePhotoUri} />
    <If condition={isSponsored}>
      <PrequalAvatar
        className={classnames(styles.cospo, styles.avatar)}
        src={sponsorPhotoUri}
      />
    </If>
    <Text paragraph>
      <If condition={isSponsored}>
        <FormattedMessage
          id='Affordability.noPrequal.cospo.heading'
          defaultMessage='Why should I get a Pre-Qual?'
        />
      </If>
      <If condition={!isSponsored}>
        <FormattedMessage
          id='Affordability.noPrequal.directLO.heading'
          defaultMessage="You don't have a Pre-Qual yet"
        />
      </If>
    </Text>
    <Text color='quiet' size='s'>
      <FormattedMessage
        id='Affordability.noPrequal.explain'
        defaultMessage='Why get a Pre-Qual? It’s a fast process, helps you better understand your true affordability, and can give you better negotiation power during the buying process.'
      />
      <If condition={isSponsored}>
        {' '}
        <FormattedMessage
          id='Affordability.noPrequal.cospo.explain'
          defaultMessage='{rea} recommends {lo}, a lender they trust for financial advice.'
          values={{
            rea: customerProfileFirstName,
            lo: sponsorProfileFullName
          }}
        />
      </If>
    </Text>

    <PrequalTabFooter>
      <Button
        primary
        onClick={onRequest}
        className={styles.centerButton}
        data-qa='prequalTab.requestButton'
      >
        <FormattedMessage
          id='Affordability.noPrequal.request'
          defaultMessage='Get My Pre-Qual'
        />
      </Button>
    </PrequalTabFooter>
  </Fragment>
)

GetPrequal.propTypes = propTypes

export default GetPrequal
